module.exports = __webpack_public_path__ + "img/link.ff5f3e44.jpg";